import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import { useFormik } from 'formik';
import { registerValidation } from '../helper/validate';
import { registerUser } from '../helper/helper';

export default function Register() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  useEffect(() => {
    if (!email) {
      toast.error("Missing email address.");
      navigate("/");
    }
  }, [email, navigate]);

  const formik = useFormik({
    initialValues: {
      firstName: '',
      email: email || '',
      password: '',
    },
    enableReinitialize: true,
    validate: registerValidation,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      let registerPromise = registerUser(values);
      toast.promise(registerPromise, {
  loading: 'Creating...',
  success: <b>Sign up successful!</b>,
  error: (err) => <b>{typeof err === 'string' ? err : err?.error || "Could not sign up."}</b>,
});


      registerPromise.then(() => navigate('/'));
    },
  });

  if (!email) return null; // Only after all hooks have been safely declared

  return (
    <div className="flex flex-col bg-white min-h-screen">
      <Toaster position="top-center" reverseOrder={false} />
      <div className="flex flex-grow items-center justify-center px-4">
        <div className="w-full max-w-sm bg-white shadow-lg rounded-lg p-6">
          <h1 className="text-2xl font-bold text-center mb-2">Create a free account</h1>

          <form className="w-full" onSubmit={formik.handleSubmit}>
            <input
              className="w-full p-3 border rounded-lg mb-4 bg-gray-100 text-gray-500"
              type="email"
              value={email}
              disabled
              readOnly
            />
            <input
              {...formik.getFieldProps('firstName')}
              className="w-full p-3 border rounded-lg mb-4"
              type="text"
              placeholder="First Name*"
              autoComplete="given-name"

            /><input
              {...formik.getFieldProps('password')}
              className="w-full p-3 border rounded-lg mb-4"
              type="password"
              placeholder="Password*"
              autoComplete="new-password"
            />
            <button
              className="w-full bg-red-500 text-white p-3 rounded-lg hover:bg-red-600"
              type="submit"
            >
              Sign up
            </button>
          </form>

          <div className="text-center py-4">
            <span className="text-gray-500">
              Already have an account?{' '}
              <Link className="text-red-500" to="/">
                Log in
              </Link>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}